/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SecurityGroupRoleAssignmentsReadModelPagedList } from './SecurityGroupRoleAssignmentsReadModelPagedList';
import {
    SecurityGroupRoleAssignmentsReadModelPagedListFromJSON,
    SecurityGroupRoleAssignmentsReadModelPagedListFromJSONTyped,
    SecurityGroupRoleAssignmentsReadModelPagedListToJSON,
    SecurityGroupRoleAssignmentsReadModelPagedListToJSONTyped,
} from './SecurityGroupRoleAssignmentsReadModelPagedList';
import type { StringReferenceReadModel } from './StringReferenceReadModel';
import {
    StringReferenceReadModelFromJSON,
    StringReferenceReadModelFromJSONTyped,
    StringReferenceReadModelToJSON,
    StringReferenceReadModelToJSONTyped,
} from './StringReferenceReadModel';

/**
 * 
 * @export
 * @interface RolesAndAssignmentsReadModel
 */
export interface RolesAndAssignmentsReadModel {
    /**
     * 
     * @type {Array<StringReferenceReadModel>}
     * @memberof RolesAndAssignmentsReadModel
     */
    roles: Array<StringReferenceReadModel>;
    /**
     * 
     * @type {SecurityGroupRoleAssignmentsReadModelPagedList}
     * @memberof RolesAndAssignmentsReadModel
     */
    assignments: SecurityGroupRoleAssignmentsReadModelPagedList;
}

/**
 * Check if a given object implements the RolesAndAssignmentsReadModel interface.
 */
export function instanceOfRolesAndAssignmentsReadModel(value: object): value is RolesAndAssignmentsReadModel {
    if (!('roles' in value) || value['roles'] === undefined) return false;
    if (!('assignments' in value) || value['assignments'] === undefined) return false;
    return true;
}

export function RolesAndAssignmentsReadModelFromJSON(json: any): RolesAndAssignmentsReadModel {
    return RolesAndAssignmentsReadModelFromJSONTyped(json, false);
}

export function RolesAndAssignmentsReadModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): RolesAndAssignmentsReadModel {
    if (json == null) {
        return json;
    }
    return {
        
        'roles': ((json['roles'] as Array<any>).map(StringReferenceReadModelFromJSON)),
        'assignments': SecurityGroupRoleAssignmentsReadModelPagedListFromJSON(json['assignments']),
    };
}

export function RolesAndAssignmentsReadModelToJSON(json: any): RolesAndAssignmentsReadModel {
    return RolesAndAssignmentsReadModelToJSONTyped(json, false);
}

export function RolesAndAssignmentsReadModelToJSONTyped(value?: RolesAndAssignmentsReadModel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'roles': ((value['roles'] as Array<any>).map(StringReferenceReadModelToJSON)),
        'assignments': SecurityGroupRoleAssignmentsReadModelPagedListToJSON(value['assignments']),
    };
}

